import {useEffect} from 'react';
import {Outlet} from 'react-router-dom';

import {useLazyWorkspaceInfoQuery} from '@dms/api/core';
import {appWorkspaceKey} from '@dms/config';
import {getWorkspaceFromUri, redirectToWorkspace} from '@dms/routes';
import {CommonSkeleton} from '@dms/shared';

import {isRunningInCypress, useNavigate} from 'shared/web';

export function WorkspaceInit() {
  const {workspace, shouldRedirectToAppWorkspace, isReviewApp} = getWorkspaceFromUri();
  const [getWorkspaceInfo, {data: workspaceInfo}] = useLazyWorkspaceInfoQuery();
  const navigate = useNavigate();

  useEffect(() => {
    if (isRunningInCypress() || isReviewApp) {
      return;
    }

    if (!workspace || shouldRedirectToAppWorkspace) {
      redirectToWorkspace();
      return;
    }

    if (!workspaceInfo && !shouldRedirectToAppWorkspace && workspace !== appWorkspaceKey) {
      getWorkspaceInfo({workspace})
        .unwrap()
        .catch(() => {
          redirectToWorkspace();
        });
      return;
    }
  }, [workspaceInfo, getWorkspaceInfo, navigate]);

  if (shouldRedirectToAppWorkspace) {
    return <CommonSkeleton />;
  }

  return <Outlet />;
}
